/**
 * Copyright (c) Microsoft. All rights reserved.
 */

export const FeatureToggles = window.luisAppSettings.featureToggles;
